import styled from 'styled-components'
import { AgGridContainer } from '../../components/ag-grid-utils/styles'
import { ResponsiblePrimaryButton } from '../../components/buttons/ResponsibleAmeButton'

export const StyledAgGridContainer = styled(AgGridContainer)`
    height: 100%;
`
export const StyledResponsiblePrimaryButton = styled(ResponsiblePrimaryButton)`
    align-self: flex-end;
    margin: 0px 20px 20px 0px;
`
export const DeleteBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60vh;
`

export const DeleteText = styled.span`
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
`
export const ButtonGroup = styled.div`
    width: 500px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
`
